import { useQuery } from '@tanstack/react-query';
import { authService } from '../../services/authService';
import { apiJson } from './apiFetch';
import { queryKeys } from '../../lib/queryKeys';
import { useCampaignStore } from '../../stores';
import type { QuestionAnswersFilter, QuestionAnswersResponse } from '@signalvote/shared';
import { buildQueryString } from './queryUtils';

export function useQuestionAnswers(questionId: string, filter: QuestionAnswersFilter) {
  const { selectedCampaign } = useCampaignStore();

  return useQuery({
    queryKey: queryKeys.analytics.questionAnswers(questionId, filter),
    queryFn: async () => {
      const qs = buildQueryString({
        answer: filter.answer,
        dateFrom: filter.dateFrom,
        dateTo: filter.dateTo,
        page: filter.page != null ? String(filter.page) : undefined,
        pageSize: filter.pageSize != null ? String(filter.pageSize) : undefined,
        sortBy: filter.sortBy,
        sortOrder: filter.sortOrder,
      });
      return apiJson<QuestionAnswersResponse>(
        `/api/campaigns/${selectedCampaign!.id}/voter-segments/by-answer/${questionId}${qs}`,
        { error: 'Failed to fetch question answers' },
      );
    },
    enabled: authService.isAuthenticated() && !!selectedCampaign && !!questionId,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
